module.exports = __webpack_public_path__ + "img/thumb_35.a8a25669.jpg";